import { Card } from "antd";
import "./index.scss";

function CustomCard({
  title,
  extra,
  content,
  bordered = true,
  defaultActiveTabKey,
  headStyle,
  tabProps,
  tabList,
  contentList,
  size = "small",
  onTabChange,
  onTabClick,
  activeTabKey,
}) {
  return (
    <Card
      title={title}
      size={size}
      extra={extra}
      bordered={bordered}
      tabList={tabList}
      activeTabKey={activeTabKey}
      headStyle={headStyle || { backgroundColor: "#e7f0ff" }}
      className="custom-card-ant"
      defaultActiveTabKey={defaultActiveTabKey}
      onTabChange={(key) => {
        onTabChange(key);
      }}
      // `onTabChange` chỉ bắn khi key đổi. Nơi nào cần bắt cả cú nhấn vào chính tab đang mở
      // thì truyền `onTabClick` — antd chuyển tiếp nó xuống Tabs qua `tabProps`.
      tabProps={onTabClick ? { onTabClick } : undefined}
      {...tabProps}
    >
      <div>{content}</div>
      <div>{contentList?.[activeTabKey]}</div>
    </Card>
  );
}

export default CustomCard;
